import { URL_CONFIG } from "./urlConfig";

export const ATP_API_URL = {
  LOGIN: `${URL_CONFIG.ATP_API_BASE_URL}api/Auth/login`,
  REQUEST_OTP: `${URL_CONFIG.ATP_API_BASE_URL}api/Auth/login`,
  VERIFY_OTP: `${URL_CONFIG.ATP_API_BASE_URL}api/Auth/verify-otp`,
  PRIMARY_CREATE_DATA: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/primary-create-onboarding`, // TODO: changed api end point

  TOTAL_COUNTS: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/total-counts`,
  PARENT_LIST: `${URL_CONFIG.ATP_API_BASE_URL}api/Onboarding/parent-list`,

  APPROVE_ENTITY: `${URL_CONFIG.ATP_API_BASE_URL}api/entity/onboarding-approved`,
  DEFICIENCY_ENTITY: `${URL_CONFIG.ATP_API_BASE_URL}api/entity/onboarding-deficiency`,

  // TODO: Old apis
  // REQUIRED_DOCUMENTS: `${URL_CONFIG.ATP_API_BASE_URL}api/entity/required-documents`,
  // UPLOAD_DOCUMENT: `${URL_CONFIG.ATP_API_BASE_URL}api/entity/upload-document`,
  // DEPARTMENT_LIST: `${URL_CONFIG.ATP_API_BASE_URL}api/entity/department-list`,
  // UPDATE_ALL_DATA: `${URL_CONFIG.ATP_API_BASE_URL}api/entity/update-onboarding`,
  // GET_ALL_DATA: `${URL_CONFIG.ATP_API_BASE_URL}api/entity/onboardingList`,
  // // TODO: searching the data and all listing data here with paginations
  // GET_ALL_DATA_SEARCH: `${URL_CONFIG.ATP_API_BASE_URL}api/entity/search-onboarding`,
};
